import React from "react";
import { useDispatch, useSelector } from "../../store";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import { Field, Form, Formik } from "formik";
import { editSiteManager, postSiteManager } from "../../slices/siteManager";
import * as Yup from "yup";
import { Inputs } from "../formInputs";
import { Base } from "../base";

interface Props {
  close: () => void;
  onSave: () => void;
}

const AddEditSiteManagerForm: React.FC<Props> = (props) => {
  const { close, onSave } = props;
  const dispatch = useDispatch();
  const { siteManager, status } = useSelector((store) => store.siteManager);
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.down("sm"));

  const handleSubmit = (values: any) => {
    if (siteManager.id === 0) {
      dispatch(postSiteManager(values)).then((result) => {
        if (result.meta.requestStatus === "fulfilled") {
          updateAfterChanged();
        }
      });
    } else {
      dispatch(editSiteManager(values)).then((result) => {
        if (result.meta.requestStatus === "fulfilled") {
          updateAfterChanged();
        }
      });
    }
  };

  const updateAfterChanged = () => {
    close();
    if (xs) {
      onSave();
    }
  };

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("Required"),
    lastName: Yup.string().required("Required"),
    // email: Yup.string().email("Must be a valid email").required("Required"),
  });

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        width: 300,
        borderRadius: "10px",
        padding: "15px",
      }}
    >
      <Formik
        initialValues={siteManager}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        enableReinitialize
      >
        <Form noValidate>
          <Grid container>
            <Grid size={{ xs: 12 }}>
              <Field
                component={Inputs.Text}
                name="firstName"
                label="First Name"
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Field
                component={Inputs.Text}
                name="lastName"
                label="Last Name"
              />
            </Grid>
            {/* <Grid size={{xs:12}}>
              <Field component={Inputs.Text} name="email" label="Email" />
            </Grid> */}
          </Grid>
          <Grid container direction={"row"} justifyContent={"space-between"}>
            <Grid>
              <Base.Button text="Cancel" type="secondary" onClick={close} />
            </Grid>
            <Grid>
              <Inputs.Submit
                isSubmitting={status === "loading"}
                text={"Save"}
              />
            </Grid>
          </Grid>
        </Form>
      </Formik>
    </Box>
  );
};

export default AddEditSiteManagerForm;
